import React, { useEffect, useState, useContext } from 'react';
import toast from 'react-hot-toast';
import {
 Col, Container, Row, Form, 
} from 'react-bootstrap';
import Pagination from 'react-bootstrap/Pagination';
import { Button, ButtonGroup } from '@/shared/components/Button';
import { FaExclamationCircle } from 'react-icons/fa';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import RequestCard from './RequestCard';
import { RestaurantContext } from '../../../../context/RestaurantContext';
import ProgressBar from '../../Loader';
import { AuthContext } from '../../../../context/AuthContext';
import { SideBarRefreshContext } from '../../../../context/SideBarRefreshContext';

const RequestList = () => {
  const [loading, setLoading] = useState(true);
  const [allRequest, setAllRequest] = useState([]);
  const { refresh, statusChanged } = useContext(RestaurantContext);
  const [filteredRequest, setFilteredRequest] = useState([]);
  const { apiGlobal } = useContext(AuthContext);
  const [searchQuery, setSearchQuery] = useState('');
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const fetchRestResponse = async () => {
    setLoading(true);
    try {
      const url = `${apiGlobal}/restaurant_notappro_list.php`;
      const response = await fetch(url);
      const data = await response.json();
      
      if (data.status && data.message === 'Success') {
        setAllRequest(data.data);
        setFilteredRequest(data?.data);
      } else if (data.status && data.message === 'No data found') {
        setAllRequest([]);
        setFilteredRequest([]);
      } else {
        toast.error('Unable to fetch RequestList');
      }
    } catch (e) {
      toast.error(`Unable to fetch RequestList: ${e.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRestResponse();
  }, [refresh, statusChanged, sideBarRefresh?.adminRestaurantRequestRefresh]);

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  
    if (query) {
      const filteredData = allRequest
      .filter(requestdata => requestdata.name.toLowerCase().includes(query.toLowerCase()));
      setFilteredRequest(filteredData); // Update filtered data only
    } else {
      setFilteredRequest(allRequest); // Reset to full list
    }
  };

  // Pagination Logic - Slice data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Use filteragent for pagination, not agent
  const currentItems = filteredRequest.slice(indexOfFirstItem, indexOfLastItem);

  // Total pages should be based on filteragent length, not agent
  const totalPages = Math.ceil(filteredRequest.length / itemsPerPage);

  const refreshHandler = () => {
    setSearchQuery('');
    fetchRestResponse();
  };

     // use Effect to add keyframes for the pulse animation
     useEffect(() => {
      // Add keyframes via JavaScript when component mounts
      const style = document.createElement('style');
      style.innerHTML = `
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.2); opacity: 0.8; }
          100% { transform: scale(1); opacity: 1; }
        }
      `;
      document.head.appendChild(style);
    }, []);

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          // justifyContent: 'center', // Center horizontally
          // alignItems: 'center', // Center vertically
          height: '100vh', // Full viewport height
        }}
      >
        <ProgressBar />
      </div>
    );
  }

  return (
    <div>
      <Container>
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
        marginBottom: '5px',
      }}
        >
          <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
          <Typography sx={{ color: 'text.primary' }}>Restaurant</Typography>
          <Typography sx={{ color: 'text.primary' }}>Request</Typography>
        </Breadcrumbs>
      </Container>
      <Container className="bg-white" style={{ padding: '20px' }}>
        
     
        <div className="d-flex w-25">
          <Form.Control
            type="text"
            placeholder="Search by Name......"
            value={searchQuery}
            onChange={handleSearch}
            style={{
               height: '30px',
               margin: '10px',
               borderColor: 'green',
               flexGrow: 1,
             }}
          />

          <ButtonGroup icons dir="ltr" style={{ marginTop: '10px' }}>
            <Button
              variant="outline-secondary"
              title="Refresh"
              size="sm"
              style={{ marginLeft: '10px' }}
              onClick={refreshHandler}
            >
              <span className="lnr lnr-sync" />
            </Button>
          </ButtonGroup>
        </div>



        <Row>
          {filteredRequest.length > 0 ? (
         currentItems.map((req, index) => (
           <RequestCard 
             key={req.id} 
             index={index} 
             date={req.created_date_time} 
             name={req.name} 
             id={req.id} 
             logo={req.photo}
           />
         ))
       ) : (
                 // If search results are empty
         <div style={{
                  textAlign: 'center',
      padding: '50px',
      backgroundColor: '#f8d7da',
      borderRadius: '8px',
      marginTop: '20px',
                  color: '#721c24',
      fontSize: '16px',
                }}
         >
           <div
             style={{
  fontSize: '48px',
  marginBottom: '20px',
  color: '#e63946',
  animation: 'pulse 1.5s infinite ease-in-out',
  display: 'inline-block',
  }}
           >
             <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
           </div>
           <p>{searchQuery ? 'No results found for your search' : 'No restaurant requests available'}</p>
         </div>
               )}
        </Row>
        <div>
          {/* Pagination Controls */}
          <div
            className=""
            style={{
           position: 'fixed',
           bottom: '20px',
           right: '20px',
         zIndex: 999, 
         display: 'flex', 
         justifyContent: 'flex-end', 
         alignItems: 'center',

       }}
          >
            {filteredRequest.length > 0 && (
              <Pagination>
                <Pagination.Prev
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                />
                {Array.from({ length: totalPages }, (_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === currentPage}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
         ))}
                <Pagination.Next
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                />
              </Pagination>
            )}
            
          </div>
        </div>
     
      </Container>
    </div>
  
  );
};

export default RequestList;
